import { AuthLayout } from 'views/layouts'

import LoginFormContainer from '../../containers/Forms/Login'

const Login = () => {
  return (
    <AuthLayout variant="admin">
      <LoginFormContainer variant="admin" />
    </AuthLayout>
  )
}

export default Login
